/** Existing application-prefill normalization, shared with individual customer capture. */
export const normalizeSouthAfricanPhoneNumber = (rawPhone?: string): string => {
  if (!rawPhone) return '';
  const digitsOnly = rawPhone.replace(/\D/g, '');
  if (digitsOnly.length === 10 && digitsOnly.startsWith('0')) return digitsOnly;
  if (digitsOnly.length === 11 && digitsOnly.startsWith('27')) return `0${digitsOnly.slice(2)}`;
  return rawPhone;
};
